// Registre minuscule des saisies EN LIGNE non enregistrées (hors dialogue : un
// dialogue ouvert bloque déjà la recharge). Lu par reloadIfUpdatePending pour
// ne jamais recharger l'onglet au retour ou après inactivité quand une fiche
// modifiée attend son enregistrement.
import { useEffect } from "react";

const dirtyKeys = new Set<string>();

export function setUnsavedChanges(key: string, dirty: boolean): void {
  if (dirty) dirtyKeys.add(key);
  else dirtyKeys.delete(key);
}

export function hasUnsavedChanges(): boolean {
  return dirtyKeys.size > 0;
}

export function resetUnsavedChangesForTests(): void {
  dirtyKeys.clear();
}

/** Déclare l'état sale d'un écran ; la clé est libérée au démontage. */
export function useUnsavedChangesGuard(key: string, dirty: boolean): void {
  useEffect(() => {
    setUnsavedChanges(key, dirty);
  }, [key, dirty]);
  useEffect(() => () => setUnsavedChanges(key, false), [key]);
}
